import React, { useState } from 'react';
import { PostProductionContent } from '../components/post-productionContent';
import { PreProductionContent } from '../components/pre-productionContent';
import '../styles/welcome.css';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



export function Welcome() {
    const [openModal, setOpenModal] = useState(false);
    const [ModalComponent, setModalComponent] = useState(null);
  
    // Function to handle card clicks and update modal content
    function handleCardClick(Component) {
      setModalComponent(() => Component);
      setOpenModal(true);
    }
  
    function handleCloseModal() {
      setOpenModal(false);
      setModalComponent(null);
    }

  return (
    <div>
        <SEO
          title="Welcome to ProducerBuddy"
          description="Welcome to ProducerBuddy — the all-in-one film production platform for filmmakers worldwide. Start your project today."
          url="https://producerbuddy.pilomation.com/welcome"
          robots="noindex, nofollow"
        />
        <div className="welcome_text mt-5">
            <h2>Welcome to Producer’s Buddy</h2>
            <h4>Turning Ideas into Visual Magic.</h4>
        </div>
        <div className="welcome_content mt-5">
            <h5>Choose the type of production</h5>
            <div className="welcome_cards">
                    <div className="welcome_card" onClick={() => handleCardClick(PreProductionContent)}>
                        <h2>Pre-production +</h2>
                    </div>
                <div className="welcome_card">
                    <h2>Production +</h2>
                </div>
            </div>
            <div className="welcome_cards">
                    <div className="welcome_card" onClick={() => handleCardClick(PostProductionContent)}>
                        <h2>Post-production +</h2>
                    </div>
            </div>
        </div>
        <div className="welcome_button mt-4">
            <button class="btn btn-secondary" type="button">Skip</button>
            <button to='/stages' class="btn btn-primary" type="button" onClick="move()">Continue</button>
        </div>
        {openModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-4xl max-h-[80vh] overflow-auto">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              &times;
            </button>
            {ModalComponent && <ModalComponent />}
          </div>
        </div>
      )}
    </div>
  )
}


